"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NONE = exports.DEFAULT_COLOR_LABEL = exports.DEFAULT_COLOR_BLOCK = exports.DEFAULT_ASPECT_RATIO = exports.DEFAULT_CONTAINER_HEIGHT = exports.DEFAULT_CONTAINER_WIDTH = void 0;
exports.DEFAULT_CONTAINER_WIDTH = 400;
exports.DEFAULT_CONTAINER_HEIGHT = 300;
exports.DEFAULT_ASPECT_RATIO = 4 / 3;
exports.DEFAULT_COLOR_BLOCK = '#9CC3FF';
exports.DEFAULT_COLOR_LABEL = 'black';
exports.NONE = 'none';
